module.exports = __webpack_public_path__ + "img/img-2.f33de31b.png";